module.exports = __webpack_public_path__ + "img/wx.c049a61f.png";